<template>
  <div class="distance">{{ distance }}km</div>
</template>

<script>
export default {
  name: "DistanceBlock",

  props: {
    lat: {
      type: Number,
      default: 0
    },
    lng: {
      type: Number,
      default: 0
    },
  },

  data() {
    return {
      distance: '~',
      clientLocation: {
        lat: 0,
        lng: 0
      }
    }
  },

  mounted() {
    this.getClientLocation();
  },

  methods: {
    getClientLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.savePosition);
      }
    },

    savePosition: function(position) {
      this.clientLocation.lat = position.coords.latitude;
      this.clientLocation.lng = position.coords.longitude;

      this.distance = this.haversineFormule(this.lat, this.lng, this.clientLocation.lat, this.clientLocation.lng);
    },

    haversineFormule: function(lat1, lon1, lat2, lon2) {
      const toRadian = angle => (Math.PI / 180) * angle;
      const distance = (a, b) => (Math.PI / 180) * (a - b);
      const RADIUS_OF_EARTH_IN_KM = 6371;

      const dLat = distance(lat2, lat1);
      const dLon = distance(lon2, lon1);

      lat1 = toRadian(lat1);
      lat2 = toRadian(lat2);

      const a =
          Math.pow(Math.sin(dLat / 2), 2) +
          Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
      const c = 2 * Math.asin(Math.sqrt(a));

      return Math.round( (RADIUS_OF_EARTH_IN_KM * c) * 100 ) / 100;
    }
  }
}
</script>